import axios from 'axios';
import { ConstructionFeeModel } from 'app/edozvola/cases/construction-fee/model/construction-fee.model';
import { CaseSegmentModel, CaseSegmentsModel } from 'app/edozvola/cases/case-segment/model/case-segment.model';

export const getSegments = async (caseUuid: string): Promise<CaseSegmentsModel> => {
  return await new Promise((resolve, reject) => {
    axios
      .get(`api/cases/${caseUuid}/segments`)
      .then(result => resolve(result.data))
      .catch(error => reject(error.response.data.detail));
  });
};

export const saveSegments = async (caseUuid: string, segments: CaseSegmentsModel): Promise<any> => {
  return await new Promise((resolve, reject) => {
    axios
      .post(`api/cases/${caseUuid}/segments`, segments)
      .then(result => {
        resolve(result.data);
      })
      .catch(error => {
        reject(error.response.data.detail);
      });
  });
};
